import './Spinner.css';

const Spinner = () => (
  <div className="spinner-overlay">
    <div className="spinner-ring">
      <div /><div /><div /><div />
    </div>
    <p className="spinner-label">Loading...</p>
  </div>
);

export default Spinner;
